import { Button } from '@ui/button.tsx';
import { CardContent, CardFooter, CardHeader, CardTitle } from '@ui/card.tsx';
import { Input } from '@ui/input.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

export function ListSkeleton() {
  return (
    <Skeleton className="sticky flex flex-col w-full bg-transparent border-2 top-5 rounded-3xl border-muted">
      <CardHeader className="h-[10%] space-y-0">
        <CardTitle className="flex items-center space-x-2">
          <div className="mr-2 rounded-md aspect-square h-7 bg-muted" />
          <div className="w-full mr-2 rounded-md h-7 bg-muted" />
        </CardTitle>
      </CardHeader>

      <CardContent className="flex h-[70%] flex-col 2xl:h-[80%]">
        <Input className="border-2 rounded-full min-h-10 border-muted" />
        <ul className="mt-5 max-h-full space-y-1.5 overflow-y-auto">
          {Array.from({ length: 8 }).map((_, i) => {
            return (
              <li
                key={i}
                className="flex cursor-pointer items-center justify-between rounded-lg bg-background p-2.5"
              >
                <div className="flex items-center w-7/12">
                  <div className="flex items-center">
                    <div className="h-10 mr-2 rounded-full aspect-square bg-muted" />
                  </div>

                  <div className="ml-2.5 space-x-2.5">
                    <div className="rounded-md h-7 w-60 bg-muted" />
                  </div>
                </div>

                <div className="flex items-center justify-end">
                  <div className="mr-2 rounded-md h-7 w-52 bg-muted" />
                </div>
              </li>
            );
          })}
        </ul>
      </CardContent>

      <CardFooter className="flex h-[20%] flex-grow flex-wrap items-end space-y-2.5 2xl:h-[10%] 2xl:flex-nowrap 2xl:space-x-5 2xl:space-y-0">
        <div className="w-full 2xl:w-6/12">
          <Button className="w-full bg-muted" />
        </div>

        <div className="w-full 2xl:w-6/12">
          <Button className="w-full bg-transparent border-2 border-muted" />
        </div>
      </CardFooter>
    </Skeleton>
  );
}
